import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import AppShell from "./layout/AppShell";
import Dashboard from "./pages/Dashboard";
import OperationsDayPage from "./pages/OperationsDayPage/OperationsDayPage";
import SalonAnalyticsPage from "./pages/SalonAnalyticsPage/SalonAnalyticsPage";
import StaffPlansPage from "./pages/StaffPlansPage/StaffPlansPage";
import StaffProfilesPage from "./pages/StaffProfilesPage/StaffProfilesPage";
import FinancePage from "./pages/FinancePage/FinancePage";
import TeamPerformancePage from "./pages/TeamPerformancePage/TeamPerformancePage";
import QualityReputationPage from "./pages/QualityReputationPage/QualityReputationPage";
import AssistantPage from "./pages/AssistantPage/AssistantPage";
import { KnowledgeLibrary, KnowledgeReader } from "./pages/KnowledgePage/KnowledgePage";
import InventoryPage from "./pages/InventoryPage/InventoryPage";
import { SupportTicketsPage } from "./pages/SupportTicketsPage/SupportTicketsPage";
import { TicketChatPage } from "./pages/TicketChatPage/TicketChatPage";
import { SupportTicketCreatePage } from "./pages/SupportTicketsPage/SupportTicketCreatePage";
import { DesignTicketsPage } from "./pages/OrderLayoutPage/DesignTicketsPage";
import { DesignChatPage } from "./pages/OrderLayoutPage/DesignChatPage";
import { DesignTicketCreatePage } from "./pages/OrderLayoutPage/DesignTicketCreatePage";
import TerminalInfoPage from "./pages/TerminalInfoPage/TerminalInfoPage";
import TerminalMarkingPage from "./pages/TerminalMarkingPage/TerminalMarkingPage";
import ProfilePage from "./pages/ProfilePage/ProfilePage";
import NotificationsPage from "./pages/NotificationsPage/NotificationsPage";
import ChatsPage from "./pages/ChatsPage/ChatsPage";
import { DocumentsPage } from "./pages/DocumentsPage/DocumentsPage";
import { CompanyInfoPage } from "./pages/CompanyInfoPage/CompanyInfoPage";
import { PromoCodesPage } from "./pages/PromoCodesPage/PromoCodesPage";
import { TransactionsPage } from "./pages/TransactionsPage/TransactionsPage";
import { RecordsPage } from "./pages/RecordsPage/RecordsPage";
import { RecordCreatePage } from "./pages/RecordsPage/RecordCreatePage";
import MonitorsAdsPage from "./pages/MonitorsAdsPage/MonitorsAdsPage";
import DesignMaketPage from "./pages/MaketOrderPage/DesignMaketPage";
import WhatsAppPage from "./pages/WhatsAppPage/WhatsAppPage";
import SchedulePage from "./pages/SchedulePage/SchedulePage";
import NotFoundPage from "./pages/shared/NotFoundPage";
import "./layout/design.scss";

export default function App() {
    return <Routes><Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/operations-day" element={<OperationsDayPage />} />
        <Route path="/schedule" element={<SchedulePage />} />
        <Route path="/salon-analytics" element={<SalonAnalyticsPage />} />
        <Route path="/staff-plans" element={<StaffPlansPage />} />
        <Route path="/staff-profiles" element={<StaffProfilesPage />} />
        <Route path="/finance" element={<FinancePage />} />
        <Route path="/team-performance" element={<TeamPerformancePage />} />
        <Route path="/quality-reputation" element={<QualityReputationPage />} />
        <Route path="/assistant" element={<AssistantPage />} />
        <Route path="/knowledge" element={<KnowledgeLibrary />} />
        <Route path="/knowledge/:id" element={<KnowledgeReader />} />
        <Route path="/inventory" element={<InventoryPage />} />
        <Route path="/support" element={<SupportTicketsPage />} />
        <Route path="/support/new" element={<SupportTicketCreatePage />} />
        <Route path="/support/ticket/:id" element={<TicketChatPage />} />
        <Route path="/order-layout" element={<DesignTicketsPage />} />
        <Route path="/order-layout/new" element={<DesignTicketCreatePage />} />
        <Route path="/order-layout/ticket/:id" element={<DesignChatPage />} />
        <Route path="/terminal" element={<TerminalInfoPage />} />
        <Route path="/terminal/marking" element={<TerminalMarkingPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/chats" element={<ChatsPage />} />
        <Route path="/chats/assistant" element={<Navigate to="/assistant?mode=chat" replace />} />
        <Route path="/chats/:chatId" element={<ChatsPage />} />
        <Route path="/budget-planner" element={<Navigate to="/finance" replace />} />
        <Route path="/documents" element={<DocumentsPage />} />
        <Route path="/company-info" element={<CompanyInfoPage />} />
        <Route path="/promocodes" element={<PromoCodesPage />} />
        <Route path="/transactions" element={<TransactionsPage />} />
        <Route path="/records" element={<RecordsPage />} />
        <Route path="/records/new" element={<RecordCreatePage />} />
        <Route path="/monitors-ads" element={<MonitorsAdsPage />} />
        <Route path="/design-maket" element={<DesignMaketPage />} />
        <Route path="/whatsapp" element={<WhatsAppPage />} />
        <Route path="/debets" element={<Navigate to="/finance?view=payments" replace />} />
        <Route path="/financialAnalytics" element={<Navigate to="/salon-analytics" replace />} />
        <Route path="/dashboards" element={<Navigate to="/salon-analytics" replace />} />
        <Route path="/maps" element={<Navigate to="/quality-reputation#reputation" replace />} />
        <Route path="/quality" element={<Navigate to="/quality-reputation" replace />} />
        <Route path="*" element={<NotFoundPage />} />
    </Route></Routes>;
}
